import React from "react";
import styles from "../styles/scss/portal.scss";
import "./index.css";
import { Button, Col, Layout, Row } from "antd";
import { generateNonce, getWeEAMUrl } from "../main/OauthUtils";
import PortalLoading from "./PortalLoading";


type LoginLayoutProps = {
  intl?: boolean;
  oAuthUrl?: string;
};

type LoginLayoutState = {
  isReady: boolean;
  oAuthUrl: string;
  error: string;
  authenticated: boolean;
};

class LoginLayout extends React.Component<LoginLayoutProps, LoginLayoutState> {
  state: LoginLayoutState = {
    isReady: false,
    oAuthUrl: undefined,
    error: undefined,
    authenticated: false
  };

  componentDidMount() {
    Promise.resolve(getWeEAMUrl()).then((url) => {
        this.setState({
          isReady: true,
          oAuthUrl: url
        });
      //window.location.assign(`${url}&nonce=${generateNonce("xxx")}`);
          try {
              const parsed = new globalThis.URL(url.toString());
              const trustedHosts = [ "bmwgroup.net", "*.bmwgroup.net", "bmwgroup.com", "*.bmwgroup.com","bmw.com","*.bmw.com"];
              const isTrustedHost = trustedHosts.some(root =>
                  parsed.hostname === root || parsed.hostname.endsWith(`.${root}`)
              ); 
              if (!isTrustedHost) {
                  return; 
              }
              parsed.searchParams.append("nonce", generateNonce("xxx"));
              const finalUrl = parsed.toString();
              //Redirect
              window.location.assign(finalUrl);
          } catch (e) {
              console.error("Invalid redirect URL:", e);
          }
      }
    )
      .catch((err) => {
        this.setState({
          isReady: true,
          error: err
        });
      });

  }

  oauthLogin() {
        const url = `${this.state.oAuthUrl}&nonce=${generateNonce("xxx")}`;
        try{
                const parsedUrl = new globalThis.URL(url.toString());
                const trustedHosts = [ "bmwgroup.net", "*.bmwgroup.net", "bmwgroup.com", "*.bmwgroup.com","bmw.com","*.bmw.com"];

                const isTrustedHost = trustedHosts.some(root =>
                  parsedUrl.hostname === root || parsedUrl.hostname.endsWith(`.${root}`)
                  );
                    if (!isTrustedHost) {
                      return; 
                  }
                  parsedUrl.searchParams.append("nonce", generateNonce("xxx"));
                  // Get the final URL
                  const finalUrl = parsedUrl.toString();
                  console.log("Redirecting to:", finalUrl);
                  window.location.assign(finalUrl);
                }
        catch(e){
                  console.error("Invalid redirect URL:", e);
                }
  }

  render() {
    const { isReady } = this.state;

    if (!isReady) {
      return <PortalLoading key={"lgnKey"} userLoading={isReady} errorMessage={undefined} />;
    }
    return (
      <div className="content" />

    );
  }
}

export default LoginLayout;
